export const formatdate = {
    // directive definition
    bind: function (el, binding) {
        if (binding.value && binding.value != '0001-01-01T00:00:00') {
            var valueSplit = binding.value.replace("-", "/").replace("-", "/").substr(0, 10).split('/');

            let objData;
            if (valueSplit[0].length == 2)
                objData = new Date(valueSplit[2] + "/" + valueSplit[1] + "/" + valueSplit[0]);
            else
                objData = new Date(binding.value);
            el.innerHTML = objData.toLocaleDateString("pt-BR");
        }
        else
            el.innerHTML = '';
    }
}

